import React, { useState, useEffect } from "react";
import {
  Table,
  Empty,
  Popconfirm,
  notification,
  Col,
  Tooltip,
  Row,
  Drawer,
  Button,
} from "antd";
import { Link } from "react-router-dom";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
  MenuUnfoldOutlined,
  OrderedListOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import FirmUpdate from "../Forms/FirmUpdate";
import { odata } from "../Filters/Helper";
import FirmAddForm from "../Forms/FirmAddForm";
import { RowHelper, ColumnHelper } from "util/TableHelper";
import RequestHandler from "util/RequestHandler";
import FirmListTableFilter from "../Filters/FirmListTableFilter";
import ProjectStepAddForm from "../Forms/ProjectStepAddForm";

const FirmList = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [order, setOrder] = useState("");

  const [firmTypeDropdown, setFirmTypeDropdown] = useState([]);
  const [wordList, setWordList] = useState([]);
  const [firmClassDropdown, setFirmClassDropdown] = useState([]);
  const [firmIdUpdate, setFirmIdUpdate] = useState("");
  const [Name, setName] = useState("");
  const [DirectiveName, setDirectiveName] = useState("");
  const [Email, setEmail] = useState("");
  const [ErpSalesCode, setErpSalesCode] = useState("");
  const [TaxOffice, setTaxOffice] = useState("");
  const [groupCode, setGroupCode] = useState("");
  const [Vkn, setVkn] = useState("");
  const [TcNo, setTcNo] = useState("");
  const [Phone, setPhone] = useState("");
  const [MobilePhone, setMobilePhone] = useState("");
  const [Fax, setFax] = useState("");
  const [Address, setAddress] = useState("");
  const [City, setCity] = useState("");
  const [State, setState] = useState("");
  const [FirmTypeValue, setFirmTypeValue] = useState("");
  const [ErpCode, setErpCode] = useState("");
  const [FirmBranchNumberUpdate, setFirmBranchNumberUpdate] = useState("");
  const [FirmClassId, setFirmClassId] = useState("");
  const [visible, setVisible] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [totalFirmCount, setTotalFirmCount] = useState("");
  const [syncButton, setSyncButton] = useState({
    visible: false,
    loading: false,
  });
  const [firmId, setFirmId] = useState("");
  const [addProjectStepVisibility, setAddProjectStepVisibility] =
    useState(false);

  const [isEditAllowed, setIsEditAllowed] = useState(true);

  useEffect(() => {
    RequestHandler.get(`/Firm/GetFirmType`).then((response) => {
      setFirmTypeDropdown(response.data);
    });
    RequestHandler.get(`/Firm/TotalFirmCount`).then((response) => {
      setTotalFirmCount(response);
    });
    RequestHandler.get(`/User/GetTenantUserDetail`).then((response) => {
      if (response.success) {
        if (response.data.isAdmin === false) {
          setIsEditAllowed(false);
        }
      }
    });
  }, []);

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;

    const conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    const order = "&$orderby=addDate desc";

    RequestHandler.get(
      `/Firm?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const showDrawerUpdate = (id) => {
    RequestHandler.get(`/Firm/GetById/${id}`).then((response) => {
      setName(response.name);
      setDirectiveName(response.directiveName);
      setEmail(response.email);
      setErpSalesCode(response.erpSalesCode);
      setTaxOffice(response.taxOffice);
      setGroupCode(response.groupCode);
      setVkn(response.vkn);
      setTcNo(response.tcNo);
      setPhone(response.phone == null ? "          " : response.phone);
      setMobilePhone(
        response.mobilePhone == null ? "          " : response.mobilePhone
      );
      setFax(response.fax);
      setAddress(response.address);
      setCity(response.city);
      setState(response.state);
      setErpCode(response.erpCode);
      setFirmTypeValue(response.firmTypeValue.toString());
      setFirmBranchNumberUpdate(response.firmBranchNumber);
      setFirmClassId(response.firmClassId);
      setFirmIdUpdate(id);
      setVisibleUpdate(true);
    });
  };

  const onClose = () => {
    setVisible(false);
  };
  const onCloseUpdate = () => {
    setVisibleUpdate(false);
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan projeler güncellenemez.",
    });
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/Firm?id=${id}`).then((res) => {
      if (res.success) {
        getTableData();
      }
    });
  };

  const getData = (val) => {
    if (val === "success") {
      getTableData();
      setVisibleUpdate(false);
      setVisible(false);
    }
  };

  const columns = [
    {
      title: "Proje Adı",
      dataIndex: "name",
      key: "name",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Proje Kodu",
      dataIndex: "firmBranchNumber",
      key: "firmBranchNumber",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "İl",
      dataIndex: "city",
      align: "center",
      key: "city",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "İlçe",
      dataIndex: "state",
      align: "center",
      key: "state",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Adres",
      dataIndex: "address",
      align: "center",
      key: "address",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    ...(isEditAllowed
      ? [
          {
            title: "Proje İlerleme Durumu",
            dataIndex: "projectStatusSummary",
            align: "center",
            key: "projectStatusSummary",
          },
        ]
      : []),
    {
      title: "Proje Adımları",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "9%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "purple", paddingTop: 10 }}
          to={`/project-step/${record.id}`}
        >
          <OrderedListOutlined />
        </Link>
      ),
    },

    ...(isEditAllowed
      ? [
          {
            title: "Proje Adımı Girişi",
            dataIndex: "id",
            align: "center",
            key: "id",
            width: "8%",
            render: (text, record) => (
              <Button
                onClick={() => {
                  if (record.isActive) {
                    setAddProjectStepVisibility(true);
                    setFirmId(record.id);
                  } else {
                    openNotificationWithIcon("warning");
                  }
                }}
                icon={<AppstoreAddOutlined />}
                type="link"
                style={{ fontSize: "120%", color: "#9254de", paddingTop: 7 }}
              ></Button>
            ),
          },
        ]
      : []),

    ...(isEditAllowed
      ? [
          {
            title: "Proje Talepleri",
            dataIndex: "id",
            align: "center",
            key: "id",
            width: "8%",
            render: (text, record) => (
              <Link
                style={{ fontSize: "120%", color: "green", paddingTop: 10 }}
                to={`/purchase-request-list?filter=firmId%20eq%20${record.id}`}
              >
                <OrderedListOutlined />
              </Link>
            ),
          },
        ]
      : []),
    ...(isEditAllowed
      ? [
          {
            title: "Proje Teklifleri",
            dataIndex: "id",
            align: "center",
            key: "id",
            width: "8%",
            render: (text, record) => (
              <Link
                style={{ fontSize: "120%", color: "blue", paddingTop: 10 }}
                to={`/quote-list?filter=firmId%20eq%20${record.id}`}
              >
                <OrderedListOutlined />
              </Link>
            ),
          },
        ]
      : []),
    ...(isEditAllowed
      ? [
          {
            title: "Proje Siparişleri",
            dataIndex: "id",
            align: "center",
            key: "id",
            width: "8%",
            render: (text, record) => (
              <Link
                style={{ fontSize: "120%", color: "#9254de", paddingTop: 10 }}
                to={`/order-list?filter=firmId%20eq%20${record.id}`}
              >
                <OrderedListOutlined />
              </Link>
            ),
          },
        ]
      : []),

    {
      title: "Proje Depo Listesi",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "9%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "gray", paddingTop: 10 }}
          to={`/firm-storage/${record.id}/${record.name}`}
        >
          <OrderedListOutlined />
        </Link>
      ),
    },
    {
      title: "Proje Onay Rol Listesi",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "9%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "cyan", paddingTop: 10 }}
          to={`/firm-approval-assignment/${record.id}/${record.name}`}
        >
          <OrderedListOutlined />
        </Link>
      ),
    },
        {
      title: "Proje Maliyet Raporu",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "9%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "#9254de", paddingTop: 10 }}
          to={`/project-cost-report-by-project/${record.id}`}
        >
          <OrderedListOutlined />
        </Link>
      ),
    },

    ...(isEditAllowed
      ? [
          {
            title: "Durum",
            dataIndex: "operation",
            align: "center",
            render: (_, record) =>
              record.isActive ? (
                <Popconfirm
                  title="Pasif yapmak istiyor musunuz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={() => handleActivePassive(record.id)}
                >
                  <a style={{ color: "green", fontSize: "130%" }}>
                    <CheckCircleOutlined />
                  </a>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="Aktif yapmak istiyor musunuz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={() => handleActivePassive(record.id)}
                >
                  <a style={{ color: "red", fontSize: "130%" }}>
                    <CloseCircleOutlined />
                  </a>
                </Popconfirm>
              ),
          },
        ]
      : []),

    ...(isEditAllowed
      ? [
          {
            title: "Düzenle",
            dataIndex: "operation",
            align: "center",
            width: "1%",
            render: (_, record) =>
              record.isActive ? (
                <a
                  onClick={() => {
                    showDrawerUpdate(record.id);
                  }}
                  style={{ color: "orange", fontSize: "130%" }}
                >
                  <EditOutlined />
                </a>
              ) : (
                <a
                  onClick={() => {
                    openNotificationWithIcon("warning");
                  }}
                  style={{ color: "orange", fontSize: "130%" }}
                >
                  <EditOutlined />
                </a>
              ),
          },
        ]
      : []),
    // {
    //   title: "Hesaplar",
    //   dataIndex: "",
    //   align: "center",
    //   render: (record) => {
    //     return (
    //       <Link
    //         style={{ fontSize: "150%" }}
    //         to={`/firm-account-list/${record.id}`}
    //       >
    //         <MenuUnfoldOutlined />
    //       </Link>
    //     );
    //   },
    // },
    // {
    //   title: "Proje Hareketleri",
    //   dataIndex: "",
    //   align: "center",
    //   width: "7%",
    //   render: (record) =>
    //     record.isActive ? (
    //       <Link
    //         style={{ fontSize: "150%", color: "purple" }}
    //         to={`/firm-transaction-list/${record.id}`}
    //       >
    //         <OrderedListOutlined />
    //       </Link>
    //     ) : (
    //       <a
    //         onClick={() => {
    //           openNotificationWithIconForTransactions("warning");
    //         }}
    //         style={{ fontSize: "150%", color: "purple" }}
    //       >
    //         <OrderedListOutlined />
    //       </a>
    //     ),
    // },
  ];

  const renderDetailString = (text) => (text ? text : "-");
  // const detailColumns = [
  //   {
  //     title: "E-posta",
  //     dataIndex: "email",
  //     render: renderDetailString,
  //   },
  //   {
  //     title: "Vergi Dairesi",
  //     dataIndex: "taxOffice",
  //     render: renderDetailString,
  //   },
  //   {
  //     title: "Adres",
  //     dataIndex: "address",
  //     render: renderDetailString,
  //   },
  //   {
  //     title: "İlçe",
  //     dataIndex: "state",
  //     render: renderDetailString,
  //   },
  //   {
  //     title: "İl",
  //     dataIndex: "city",
  //     render: renderDetailString,
  //   },
  //   {
  //     title: "Fax Numarası",
  //     dataIndex: "fax",
  //     render: renderDetailString,
  //   },
  //   {
  //     title: "Cep Telefonu",
  //     dataIndex: "mobilePhone",
  //     render: renderDetailString,
  //   },
  //   {
  //     title: "Ev Telefonu",
  //     dataIndex: "phone",
  //     render: renderDetailString,
  //   },
  // ];

  const onAddProjectStepSuccess = () => {
    getTableData();
    setAddProjectStepVisibility(false);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: 10 }}>
            <BarsOutlined /> PROJE LİSTESİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <span style={{ marginRight: 50, fontSize: 16 }}>
            {" "}
            Proje Sayısı: {totalFirmCount}
          </span>

          <Button
            style={{ marginTop: 8 }}
            type="primary"
            onClick={() => setVisible(true)}
          >
            <PlusOutlined /> Proje Ekle
          </Button>
        </Col>
      </Row>

      <FirmListTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        extraText=""
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            // expandable={{
            //   expandedRowRender: (row) =>
            //     RowHelper.renderRowDetail({
            //       data: row,
            //       columns: detailColumns,
            //     }),
            // }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey="id"
            filterable={true}
            size="small"
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
          />
        </Col>
      </Row>

      <Drawer
        title="Proje Ekle"
        width={241}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <FirmAddForm />
      </Drawer>

      <Drawer
        title="Proje Güncelle"
        width={241}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <FirmUpdate
          firmId={firmIdUpdate}
          Name={Name}
          DirectiveName={DirectiveName}
          Email={Email}
          ErpSalesCode={ErpSalesCode}
          TaxOffice={TaxOffice}
          Vkn={Vkn}
          TcNo={TcNo}
          GroupCode={groupCode}
          wordList={wordList}
          Phone={Phone}
          sendDataForUpdate={getData}
          MobilePhone={MobilePhone}
          Fax={Fax}
          Address={Address}
          City={City}
          State={State}
          FirmTypeValue={FirmTypeValue}
          FirmBranchNumber={FirmBranchNumberUpdate}
          FirmClassId={FirmClassId}
          firmTypeDropdown={firmTypeDropdown}
          firmClassDropdown={firmClassDropdown}
          ErpCode={ErpCode}
        />
      </Drawer>

      <Drawer
        id="addProjectStep"
        title="Proje Adımı Girişi"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddProjectStepVisibility(false)}
        visible={addProjectStepVisibility}
        destroyOnClose={true}
      >
        <ProjectStepAddForm
          firmId={firmId}
          onSuccess={onAddProjectStepSuccess}
        />
      </Drawer>
    </>
  );
};

export default FirmList;
